// extracted by mini-css-extract-plugin
export default {"wrapper":"Payment_wrapper__YWjRq","inputs":"Payment_inputs__Bl7EI"};